// Constants for different requests for current reducer
export default {
  userManuals: 'USER_MANUALS',
};
